import { FilterableInterface } from './filterable.interface';

export class Source implements FilterableInterface {
  constructor(
    public hash?: string,
    public name?: string,
    public active?: boolean
  ) { }

  get filterableData() {
    return this.name.toLowerCase();
  }

  clone() {
    return new Source (
      this.hash,
      this.name,
      this.active
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/source.ts